import React, { useEffect, useState } from 'react';
import { Carousel, Button, Card } from 'react-bootstrap';
import Footer from './components/footer';
import Header from './components/Header';
import {ArrowBackIosOutlined, ArrowCircleLeft, ArrowCircleRightSharp, ArrowForward, CalendarMonth} from '@mui/icons-material'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Contact from './components/contact';
import { Spinner } from 'react-bootstrap';
import About from './components/about';
import Partners from './components/partners';
import Services from './components/services';
import ClientRemarks from './components/clientRemarks';
import Experiences from './components/experiences';
import Education from './components/education';
const Home = ({news, audioNews, videoNews, newsCategories, books, sliders, services}) => {
  const navigate = useNavigate()
  const [readyState, setReadyState] = useState(false);

  window.start_load();
  setTimeout(() => {
   
    setReadyState(true)
    window.stop_load();
  }, 500)

  function chechReadyState(){
    if(readyState){
      window.start_load();

    }else{
      window.stop_load();
    }
  }
  // useEffect(() => {
  //   news.length > 0 && audioNews.length > 0 && videoNews.length > 0 && 
  // newsCategories.length > 0 && setReadyState(true);
  // }, [])

  useEffect(() => {
    // chechReadyState()
  }, [readyState])
  return readyState && ( 
  <div style={{ overflowX:'hidden' }}>
      <Header activeState={'home'}/>
      {/* <h2> HOME PAGE </h2> */}
      <div className='row slider mt-5'
      style={{
        // height:window.innerWidth > 450? 500 : 400,
        
    }}
      >
          <div className='col-lg-8 col-md-8 col-12 mt-4 container p-4'
          style={{ borderRightStyle: 'groove', borderRightColor: 'black' }}
          >
            <h1> Welcome 
            <span class="wave-emoji">
                <img alt="👋" draggable="false" 
                className='hello'
                src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/1f44b.png" style={{height: "1em", width: "1em", margin: "0px 0.05em 0px 0.1em", verticalAlign: "-0.1em"}}/>
            </span>!!!</h1>
            <h3 
            style={{ fontWeight: 400 }}
            >I am Usman Abubakar 
            </h3>
            <h4
            style={{ fontWeight:300 }}
            > It's a pleasure having you. <br/> I am a keen Full Stack Software Developer with several years experiences with small and enterprise level production applications. </h4>
          </div>
          <div className='col-lg-4 col-md-4 col-12 mt-4'
          
          >
            <h4> RECENT PROJECTS </h4>
            <Carousel variant='dark'
            
            controls={false}
            indicators={false}
            pause={false}
            >
              
                {
                    sliders.map(function(slider,index){
                      console.log(slider.img)  
                      return (     
                            <Carousel.Item key={index}
                            variant='dark'
                            className=''
                            
                            >
                              {/* <Carousel.Caption
                              className=''
                              style={{ backgroundColor: 'whitesmoke', color: 'black', opacity: '95%' }}
                              > */}
                                <div className='mb-2'>
                                
                                <small>{slider.title}</small>
                                </div>
                              {/* </Carousel.Caption> */}
                            <center>
                              <img
                              // width={'600px'}
                              // style={{ borderRadius: '10%' }}
                              className={" h-100 w-100 text-center slide-image" }
                              src={slider.img}
                              alt={`${slider.title} - Image - ${index}`}
                              />
                            
                            </center>
                            </Carousel.Item>
                      )
                    })
                }
            </Carousel>
          </div>

      </div>
      <div style={{ backgroundColor: '' }}>
        
      <div id='about'>
          <hr />
          <About />
       </div>
        <Partners />
        <hr />
        <ClientRemarks />
        <hr />
        <Experiences />
        {/* <Education /> */}
       <div id='contact'>
        <hr />
        <Contact />
       </div>
      </div>
      
      {/* <Footer activeState={'home'} /> */}
    </div>
  )
}

export default Home
